import { Controller } from "@hotwired/stimulus"

// Handles consent checkbox validation and submit button state
export default class extends Controller {
  static targets = ["checkbox", "submit", "hiddenInput"]

  connect() {
    this.updateButtonStates()
  }

  toggle() {
    this.updateButtonStates()
  }

  updateButtonStates() {
    // Check if all checkboxes are checked
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked)

    // Enable/disable all submit buttons
    this.submitTargets.forEach(button => {
      button.disabled = !allChecked
    })

    // Update hidden input values based on checkbox states
    this.checkboxTargets.forEach(checkbox => {
      const name = checkbox.id.replace('_consent', '')
      const hiddenInputs = this.hiddenInputTargets.filter(input =>
        input.name === `${name}_consent`
      )

      hiddenInputs.forEach(input => {
        input.value = checkbox.checked ? 'accepted' : ''
      })
    })
  }
}
